import PracticeForm from "../Forms/PracticeForm";
import PracticeStyle from "../styles&pics/PracticeStyle";

const Practice = () => {
  return (
    <>
      <PracticeStyle />
      <main className="practice-main">
        <PracticeForm /> 
      </main>
    </>
  )
}

export default Practice;

